import ChargeBank from './ChargeBank'

/**
 * #1188 Phase 2: Revolut ユーザ向けチャージ画面。
 * backend 経路 (customer_balance jp_bank_transfer) は ChargeBank と同一で、
 * 表示コピー・訴求 (Revolut アプリからの国内振込) だけ差別化した薄い wrapper。
 * 実装は ChargeBank に集約 (variant='revolut')。
 */
export default function ChargeRevolut() {
  return <ChargeBank variant="revolut" />
}
